import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
const className = "ScaleCmd";
export class ScaleCmd {
    static create(scaleX, scaleY, pivotX, pivotY) {
        var cmd = Pool.getItemByClass(className, ScaleCmd);
        cmd.scaleX = scaleX;
        cmd.scaleY = scaleY;
        cmd.pivotX = pivotX;
        cmd.pivotY = pivotY;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        runner._scale(this.scaleX, this.scaleY, this.pivotX + gx, this.pivotY + gy);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(-this.pivotX, -this.pivotY);
        tempMatrix.scale(this.scaleX, this.scaleY);
        tempMatrix.translate(this.pivotX, this.pivotY);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return ScaleCmd.ID;
    }
}
ScaleCmd.ID = className;
const tempMatrix = new Matrix();
